import * as getters from './getters'
import mutations from './mutations'
import * as actions from './actions'

const state = {
  products: [],
  filterParams: {
    page: 1,
    per_page: 20,
    sort_by: 'created_at',
    order_by: 'desc',
    query: '',
  },
  isFetching: false,
  productPagination: {
    count: null,
    current: null,
    previous: null,
    next: null,
    pages: null,
    per_page: null,
  },
  productsLoading: false,
  productsLoaded: false,
  productList: [],
  dateList: [],
  selectedDate: null,
  deletedProducts: [],
}

export default {
  state,
  getters,
  mutations,
  actions,
}
